import React from 'react';

import { DisplayValueFormatterProps } from '@tableau/widgets/lib/src/widgets/ListMenuDisplayFormatters/DisplayValueFormatter';
import { Messages } from '../../codegen/Localize';
import { getOutputOperationTypeHelpText, getRefreshTypeDisplayText } from '../../flow/utils/FlowOutputStepUtils';
import { FlowOutputStepInfo } from '../../ts/models/FlowOutputStepInfo';
import { OutputOperationType } from '../../ts/ServerApi/types/FlowOutputStep';
import { RunFlowSubMenuItemStyles as styles } from './styles/RunFlowSubMenuItemStyles';

export type RunFlowSubMenuItemProps = {
  readonly iconStyle?: React.CSSProperties;
  readonly isDefault?: boolean;
  readonly displayText: string;
  readonly helpText: string;
};

// Menu item for refresh types
export class RunFlowSubMenuItem extends React.PureComponent<RunFlowSubMenuItemProps> {
  public render(): JSX.Element {
    return (
      <div className={styles.root}>
        {this.props.iconStyle && <div style={this.props.iconStyle} className={styles.subMenuIcon} />}
        <div className={styles.subMenuText}>{this.props.displayText}</div>
        {this.props.isDefault && <div className={styles.defaultText}>{Messages.writeOptionsDefault()}</div>}
        <div className={styles.subMenuHelpText}>{this.props.helpText}</div>
      </div>
    );
  }

  public toString(){
    return  this.props.displayText;
  }
}

//// Pre-configued menu items for dropdown list
export const writeOptionsRunAllDefault = () =>
  <RunFlowSubMenuItem displayText={Messages.writeOptionsRunAllDefault()} helpText={Messages.writeOptionsDefaultHelpText()} />;

export const writeOptionsRunAllFull = (isDefault: boolean = true) =>
  <RunFlowSubMenuItem displayText={Messages.writeOptionsFull()} isDefault={isDefault} helpText={Messages.writeOptionsFullHelpText()} />;

export const writeOptionsRunAllIncremental = () =>
  <RunFlowSubMenuItem displayText={Messages.writeOptionsIncremental()}
    helpText={Messages.writeOptionsIncrementalHelpText() + Messages.writeOptionsFallbackHelpText()} />;

export const writeOptionsFull = (step: FlowOutputStepInfo, isDefault: boolean = true) =>
  <RunFlowSubMenuItem
    displayText={getRefreshTypeDisplayText(false, step.outputOperationType)}
    isDefault={isDefault}
    helpText={Messages.writeOptionsFullHelpText()} />;

export const writeOptionsIncremental = (step: FlowOutputStepInfo) =>
  <RunFlowSubMenuItem
    displayText={getRefreshTypeDisplayText(true, step.incrementalOutputOperationType)}
    isDefault={step.isIncrementalDefault}
    helpText={Messages.writeOptionsIncrementalHelpText() + Messages.writeOptionsBundleHelpText()} />;

//// Wrap all above as formatters for generic flyout
export const writeOptionsRunAllDefaultFormatter = formatterWrapper(writeOptionsRunAllDefault);
export const writeOptionsRunAllFullFormatter = formatterWrapper(writeOptionsRunAllFull);
export const writeOptionsRunAllIncrementalFormatter = formatterWrapper(writeOptionsRunAllIncremental);
export const writeOptionsFullFormatter = (output: FlowOutputStepInfo) => formatterWrapper(() => writeOptionsFull(output));
export const writeOptionsIncrementalFormatter = (output: FlowOutputStepInfo) => formatterWrapper(() => writeOptionsIncremental(output));

// Convert react component to Formatter
function formatterWrapper(getRunFlowSubMenuItem: () => JSX.Element): React.ComponentClass<DisplayValueFormatterProps> {
  return class Formatter extends React.Component<DisplayValueFormatterProps> {
    public render(): JSX.Element {
      return getRunFlowSubMenuItem();
    }
  };
}
